import{REQUEST_PAGE_CONFIG,RECEIVE_PAGE_CONFIG,ERROR_PAGE_CONFIG}from"../../constants/ActionTypes";/**
 * Creates the dispatched REQUEST_PAGE_CONFIG action object.
 * @param {Object} pageId The page to get the widgets for.
 * @returns {Object} The dispatched action object.
 */export var requestPageConfig=function requestPageConfig(pageId){return{type:REQUEST_PAGE_CONFIG,pageId:pageId};};/**
 * Creates the dispatched RECEIVE_PAGE_CONFIG action object.
 * @param {Object} pageId The page id.
 * @param {Object} config The page configuration.
 * @returns {Object} The dispatched action object.
 */export var receivePageConfig=function receivePageConfig(pageId,config){return{type:RECEIVE_PAGE_CONFIG,pageId:pageId,config:config};};/**
 * Creates the dispatched ERROR_PAGE_CONFIG action object.
 * @param {Object} pageId The page id.
 * @param {string} errorCode The error code.
 * @returns {Object} The dispatched action object.
 */export var errorPageConfig=function errorPageConfig(pageId,errorCode){return{type:ERROR_PAGE_CONFIG,pageId:pageId,errorCode:errorCode};};